export default __webpack_public_path__ + "static/media/turquoise.61dcddfd.svg";